import { Button } from "primereact/button";
import { useState, useRef } from "react";
import { Toast } from "primereact/toast";
import localeText from "../../locale";

export default function ShareButton({ title, url = window.location.href }) {
  const [shareSupported, setShareSupported] = useState("share" in navigator);
  const toast = useRef(null);

  const handleShare = async () => {
    if (!shareSupported) {
      navigator.clipboard
        .writeText(url)
        .then(() => showToast(localeText("linkCopied")))
        .catch((err) => showToast(localeText("errorCopyingLink", { message: err.message })));
      return;
    }

    try {
      await navigator.share({
        title,
        url,
      });
      showToast(localeText("sharedSuccessfully"));
    } catch (error) {
      if (error.name === "AbortError") {
        showToast(localeText("sharingCanceled"));
      } else {
        showToast(localeText("errorSharing", { message: error.message }));
      }
    }
  };

  const showToast = (message) => {
    toast.current.show({ severity: "info", summary: localeText("result"), detail: message, life: 3000 });
  };

  return (
    <div>
      <Toast ref={toast} />
      <Button onClick={handleShare} className="col-12 p-2 p-no-outline" link>
        <i style={{ color: "#505F79" }} className="pi pi-share-alt text-2xl"></i>
      </Button>
    </div>
  );
}
